<template>
  <div class="footer-contact">
    <Jumbo class="footer-contact__jumbo" size="fit">
      <template #before>
        <div class="contact-jumbo__claim">
          <h2 class="footer-contact__title">¿Quieres más información?</h2>
          <p class="footer-contact__claim">Habla con un experto hipotecario.</p>
        </div>
      </template>
      <template #after>
        <div class="footer-contact__info">
          <div v-for="link in links" :key="link.content[0]" class="footer-contact__item">
            <Icon class="footer-contact__icon" :name="link.icon" color="none" />
            <div class="footer-contact__links">
              <a v-for="item in link.content" :key="item" :href="link.href + item">{{ item }}</a>
            </div>
          </div>
        </div>
        <WeCallYou />
      </template>
    </Jumbo>
  </div>
</template>

<script>
import Jumbo from '@/lego/components/layout/Jumbo.vue';
import Icon from '@/lego/components/icons/Icon.vue';
import WeCallYou from '@/lego/partials/home/WeCallYou.vue';

export default {
  components: {
    Jumbo,
    Icon,
    WeCallYou,
  },
  setup() {
    return {
      links: [
        {
          content: ['hola@trioteca.com'],
          icon: 'email',
          href: 'mailto:',
        },
        {
          content: ['910 054 391'],
          icon: 'phone',
          href: 'tel:',
        },
      ],
    };
  },
};
</script>

<style lang="postcss" scoped>
.footer-contact {
  @apply pt-xs pb-sm sm:py-lg text-neutral-ultradark bg-neutral-white border-neutral-light border-t-thin;

  &__jumbo {
    @apply container flex flex-col container-medium gap-y-xs gap-x-xl xl:gap-x-xxxl sm:flex-row;
  }

  &__title {
    @apply style-subtitle-bold mb-nano;
  }

  &__claim {
    @apply style-body;
  }

  &__info {
    @apply flex flex-col gap-micro;
  }

  &__item {
    @apply flex gap-micro;
  }

  &__links {
    @apply flex flex-col w-full;

    a {
      @apply hover:underline;
    }
  }

  /deep/ .jumbo__content {
    @apply items-start p-0 sm:flex-row gap-x-xl gap-y-xs;

    &--before {
      @apply sm:w-fit w-full sm:text-left text-center;
    }
    &--after {
      @apply flex flex-col lg:flex-row gap-sm lg:gap-xxl mx-auto sm:m-0;

      .we-call-you__btn {
        @apply m-0;
      }
    }
  }
}
</style>
